var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameUis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 24,
    height: 30,
    rx: 2,
    stroke: "#626569",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56694 4.06694C9.81102 3.82286 9.81102 3.42714 9.56694 3.18306C9.32286 2.93898 8.92714 2.93898 8.68306 3.18306L6.18306 5.68306C5.93898 5.92714 5.93898 6.32286 6.18306 6.56694C6.42714 6.81102 6.82286 6.81102 7.06694 6.56694L9.56694 4.06694ZM12.4836 4.48361C12.7277 4.23953 12.7277 3.8438 12.4836 3.59973C12.2395 3.35565 11.8438 3.35565 11.5997 3.59973L6.59973 8.59972C6.35565 8.8438 6.35565 9.23953 6.59973 9.48361C6.8438 9.72769 7.23953 9.72769 7.48361 9.48361L12.4836 4.48361Z",
    fill: "#FFA89E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16L13.5 20.3301V11.6699L21 16Z",
    stroke: "#EC5341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameUis);
export default __webpack_public_path__ + "static/media/game_uis.ce4b27f98dc73c339b188e0943c0e90b.svg";
export { ForwardRef as ReactComponent };